var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisitor = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 24.933,
  viewBox: "0 0 30 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.3571 8.5C20.3571 7.09104 19.7927 5.73978 18.7881 4.74349C17.7834 3.74721 16.4208 3.1875 15 3.1875C13.5792 3.1875 12.2166 3.74721 11.2119 4.74349C10.2073 5.73978 9.64286 7.09104 9.64286 8.5C9.64286 9.90896 10.2073 11.2602 11.2119 12.2565C12.2166 13.2528 13.5792 13.8125 15 13.8125C16.4208 13.8125 17.7834 13.2528 18.7881 12.2565C19.7927 11.2602 20.3571 9.90896 20.3571 8.5ZM6.42857 8.5C6.42857 6.24566 7.33163 4.08365 8.93908 2.48959C10.5465 0.895533 12.7267 0 15 0C17.2733 0 19.4535 0.895533 21.0609 2.48959C22.6684 4.08365 23.5714 6.24566 23.5714 8.5C23.5714 10.7543 22.6684 12.9163 21.0609 14.5104C19.4535 16.1045 17.2733 17 15 17C12.7267 17 10.5465 16.1045 8.93908 14.5104C7.33163 12.9163 6.42857 10.7543 6.42857 8.5ZM3.30134 30.8125H26.7054C26.1094 26.609 22.4665 23.375 18.067 23.375H11.9464C7.54687 23.375 3.90402 26.609 3.30804 30.8125H3.30134ZM0 32.0277C0 25.4867 5.34375 20.1875 11.9397 20.1875H18.0603C24.6562 20.1875 30 25.4867 30 32.0277C30 33.1168 29.1094 34 28.0112 34H1.98884C0.890625 34 0 33.1168 0 32.0277Z",
  fill: "#252525"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisitor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visitor.935f3a76913fc65b80cc036dccb74d41.svg";